import { Component, OnInit } from '@angular/core';
import { changeLog, IBuild, ICommit, IVersion } from 'src/main/webapp/assets/changelog';

/**ToDo Documentazione */
@Component({
  selector: 'app-changelog',
  styleUrls: ['./changelog.component.scss'],
  templateUrl: './changelog.component.html'
})
export class ChangelogComponent implements OnInit {
  public versions: IVersion[] = [];

  public ngOnInit(): void {
    this.GetVersions();
  }

  private SubstringBetween(text: string, first: string, second: string): string {
    const temp = text.indexOf(first) + first.length;

    return text.substring(temp, text.indexOf(second, temp));
}
  private GetCommits(text: string): ICommit[] {
    const commits: ICommit[] = [];

    const rows: string[] = text.split('|');
    rows.forEach(row => {
      let type = this.SubstringBetween(row, '[', ']');
      const issue = this.SubstringBetween(row, '{', '}');
      const message = row.replace(`[${type}]`, '').replace(`{${issue}}`, '');
      if (type === '') {
        type = 'Generic';
      }
      const commit: ICommit = { issue, text: message, type };

      commits.push(commit);
    });

    return commits;
  }
  private GetVersions(): void {
    const changelogs = changeLog;
    for (let nBuild = changelogs.length - 1; nBuild >= 0; nBuild--) {
      if (this.versions.length === 0) {
        const build: IBuild = {
          build: changelogs[nBuild].build,
          commits: this.GetCommits(changelogs[nBuild].text),
          date: changelogs[nBuild].date
        };
        const version: IVersion = {
          builds: [],
          version: changelogs[nBuild].version
        };
        version.builds.push(build);

        this.versions.push(version);
      } else {
        const build: IBuild = {
          build: changelogs[nBuild].build,
          commits: this.GetCommits(changelogs[nBuild].text),
          date: changelogs[nBuild].date
        };
        if (this.versions.find(v => v.version === changelogs[nBuild].version)) {
            this.versions.find(v => v.version === changelogs[nBuild].version)?.builds.push(build);
        }
        else {
          const version: IVersion = {
            builds: [],
            version: changelogs[nBuild].version
          };
          version.builds.push(build);

          this.versions.push(version);
        }
      }
    }
  }
}
